(function twainCaptureModuleDefinition() {

    angular.module("TwainCapture", ['ui.bootstrap.modal'])
        .config([
            function() {

                Dynamsoft.WebTwainEnv.AutoLoad = false;

            }
        ]);

})();